import { YesOrNo } from '@remodeling/base';

/**
 * 전문가(홈에디터) 콘텐츠 보유 여부 응답값을 boolean 으로 변환한다.
 *
 * checkCounselor API 가 content-info-service 로 이관되면서(VLOW-100)
 * 응답이 'true'/'false' 에서 'Y'/'N' 으로 바뀌었다.
 */
export const parseCounselorYn = (counselorYn?: YesOrNo): boolean =>
  counselorYn === 'Y';
